import { NgModule } from '@angular/core';
import { AngularSimpleLibComponent } from './angular-simple-lib.component';



@NgModule({
  declarations: [AngularSimpleLibComponent],
  imports: [
  ],
  exports: [AngularSimpleLibComponent]
})
export class AngularSimpleLibModule { }
